import { FunctionComponent, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import styles from './staffPage.module.scss'
import StaffHandler from './list'
import { useAuth } from '@/modules/context/AuthContext'
import { useQuery } from '@apollo/client'
import { StaffWithLinks } from '@/types/Staff'
import { GET_STAFF_LIST } from '@/modules/API/staff/staffHandler'
import Loading from '@/components/Loading/Loading'

const StaffPage: FunctionComponent = () => {
    const { user } = useAuth()

    const canDraft: boolean = !!user?.currentDaycareRights.canWriteStaffRights
    const canRead: boolean = !!user?.currentDaycareRights.canReadStaffRights

    const [staffsListData, setStaffsListData] = useState<Array<StaffWithLinks>>([])

    const {
        loading: loadingStaffList,
        data: dataStaffList,
        refetch: refetchStaffList
    } = useQuery(GET_STAFF_LIST, {
        variables: {
            daycareId: Number(user?.currentDaycare?.id)
        },
        fetchPolicy: 'network-only'
    })

    useEffect(() => {
        if (dataStaffList) {
            setStaffsListData(dataStaffList.getStaffList)
        }
    }, [dataStaffList])

    async function refetchAllStaffList(): Promise<void> {
        const { data } = await refetchStaffList()
        if (data) {
            setStaffsListData(data.getStaffList)
        }
    }

    useEffect(() => {
        if (user?.currentDaycare) {
            setStaffsListData([])
            refetchAllStaffList()
        }
    }, [user?.currentDaycare])

    return user && user.currentDaycare && user.currentDaycareRights.hasStaffAccess ? (
        <div className={styles.PagePosition}>
            {loadingStaffList && <Loading overall />}
            <StaffHandler
                staffsListData={staffsListData}
                refetchAllStaffList={refetchAllStaffList}
                canDraft={canDraft}
                canRead={canRead}
            />
        </div>
    ) : (
        <Navigate to='/' replace />
    )
}

export default StaffPage
